<div class="conflict-modal-container">
  <!-- Header -->
  <div class="modal-header">
  <div class="header-content">
    <div class="icon-container">
      <mat-icon class="warning-icon">warning</mat-icon>
    </div>
    <div class="header-text">
      <h2>Error al Unificar</h2>
    </div>
  </div>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>


  <!-- Content -->
  <div class="modal-content">
    <!-- Alert Message -->
    <div class="alert-box">
      <p>
        <strong>No es posible unificar estos pedidos</strong> porque contienen el mismo material
        con {{ data.allowDiffComercialConds ? 'unidades de medida' : 'condiciones comerciales' }} diferentes.
        Revisa los detalles a continuación:
      </p>
    </div>

    <!-- Materials List -->
    <div class="materials-list">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let conflict of data.conflicts; trackBy: trackByMaterialCode"
          [expanded]="isExpanded(conflict.materialCode)" (opened)="onPanelToggle(conflict.materialCode, true)"
          (closed)="onPanelToggle(conflict.materialCode, false)" class="material-panel">

          <!-- Panel Header -->
          <mat-expansion-panel-header class="material-header">
            <mat-panel-title class="material-title">
              <div class="material-icon">
                <mat-icon>inventory_2</mat-icon>
              </div>
              <div class="material-info">
                <span class="material-code">{{ conflict.materialCode }}</span>
                <span class="material-name">{{ conflict.materialName }}</span>
              </div>
              <span class="orders-badge">{{ conflict.orders.length }} pedidos</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Panel Content -->
          <div class="orders-container" (click)="$event.stopPropagation()">
            <div *ngFor="let order of conflict.orders; trackBy: trackByOrderSerial" class="order-card">
              <div class="order-content">
                <div class="order-icon">
                  <mat-icon>description</mat-icon>
                </div>

                <div class="order-details">
                  <!-- Serial con navegación -->
                  <div class="order-serial-container">
                    <app-document-navigation [documentType]="order.documentType" [documentSerial]="order.serial"
                      class="serial-navigation">
                    </app-document-navigation>
                  </div>

                  <!-- UMV -->
                  <div class="uom-info">
                    <span class="label">UMV:</span>
                    <span class="uom-code">{{ order.soldUnitOfMeasure?.code || 'N/A' }}</span>
                    <span class="uom-name">({{ order.soldUnitOfMeasure?.name || order.soldUnitOfMeasure?.description ||
                      'N/A' }})</span>
                  </div>
                </div>

                <!-- Precio solo si no se permite diferencia -->
                <div *ngIf="!data.allowDiffComercialConds && order.unitPrice !== undefined" class="price-badge">
                  <mat-icon class="price-icon">attach_money</mat-icon>
                  <span>{{ order.unitPrice | number:'1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <!-- Footer -->
  <mat-dialog-actions class="modal-footer">
    <button mat-raised-button color="primary" (click)="close()" class="action-button">
      Cerrar
    </button>
  </mat-dialog-actions>
</div>